import {useEffect} from 'react';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import {useLocation, useNavigationType, createRoutesFromChildren, matchRoutes} from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

const env = import.meta.env.VITE_DB_ENV;

const TRACE_URLS = ['https://*.azurestaticapps.net', 'https://*.drivn.fr'];

const tracePatterns = TRACE_URLS.map(url => {
  const regexPattern = url.replace(/\./g, '\\.').replace(/\*/g, '.*');

  return new RegExp(`^https://${regexPattern}`);
});

const CONSOLE_LOG_LEVELS_CAPTURED = ['error'];

Sentry.init({
  environment: env,
  dsn: 'https://6ac6f3e05fe8be7dbf04cfafbd31eea6@o4508119548166144.ingest.de.sentry.io/4508126275108944',
  sampleRate: 1.0, // Capture 100% of errors
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration({
      maxReplayDuration: 1000000
    }),
    Sentry.captureConsoleIntegration({
      levels: CONSOLE_LOG_LEVELS_CAPTURED
    })
  ],
  attachStacktrace: true, // This allows to attach stack traces event for non-exception events (eg: logs)
  tracesSampleRate: 1.0,
  tracePropagationTargets: tracePatterns,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  initialScope: {
    tags: {client: import.meta.env.VITE_COMPANY_NAME}
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
